import { Button, ButtonProps } from '@almbrand/button';
import { LoadingSpinner } from '@almbrand/loadingspinner';
export interface ButtonComponentProps extends ButtonProps {
	label: string;
	isValid: boolean;
	isLoading?: boolean;
}
export const ButtonComponent: React.FC<ButtonComponentProps> = ({ ...props }) => {
	return (
		<Button
			{...props}
			type={props.type ?? 'submit'}
			disabledWithSubmit={!props.isValid}
		>
			{props.isLoading && (
				<>
					<LoadingSpinner
						style='small'
						type='dottedCircle'
						color='primary'
					/>{' '}
				</>
			)}
			{props.label}
		</Button>
	);
};
